import { REDUCER_NAME } from './const'

const NS =  REDUCER_NAME + '/'

export const TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT = 'allOpenTaskWithAttachment'

export const FIND_TASK_LIST_WITH_ATTACHMENT_REQUEST = NS + 'FIND_TASK_LIST_WITH_ATTACHMENT_REQUEST'
export const FIND_TASK_LIST_WITH_ATTACHMENT_SUCCESS = NS + 'FIND_TASK_LIST_WITH_ATTACHMENT_SUCCESS'
export const FIND_TASK_LIST_WITH_ATTACHMENT_ERROR = NS + 'FIND_TASK_LIST_WITH_ATTACHMENT_ERROR'

export const CHANGE_TABLE_SETTING = NS + 'CHANGE_TABLE_SETTING'

export const TABLE_PROCESS_WORKLIST = 'ProcessWorklist'


// WEBPACK FOOTER //
// ./src/modules/worklist-attachment/state/type.js